<template>
    <v-dialog v-model="$store.state.tracking.totalDrop" width="1200px">
        <v-container grid-list-xs fluid>
            <v-card>
                <v-toolbar dark color="primary" dense>
                    <v-spacer></v-spacer>
                    <h3>{{ Title }}</h3>
                    <v-spacer></v-spacer>
                    <v-btn
                dark
                icon
                left
                @click="$store.state.tracking.totalDrop = false"
                ><v-icon>mdi-close</v-icon></v-btn
            >
                </v-toolbar>
                <v-container grid-list-xs fluid>
                    <v-simple-table v-if="spinner" dense>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>User</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(itm, indx) in items" v-bind:key="indx">
                                <td>{{ itm.name }}</td>
                                <td>{{ itm.email }}</td>
                                <td>{{ itm.Total }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-row justify="center" class="mt-5" v-else>
                        <v-col cols="1">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
import axios from 'axios';
export default {
    props:['Shift','Title'],
    data: () => ({
        items: [],
        spinner: false
    }),

    mounted() {
        console.log(this.Shift.ShiftDate);
        this.loadTotals(this.Shift);
    },
    methods: {
        loadTotals: async function(Shift) {
            var str = this.$store;
            var parms = {
                ShiftHeaderNum: Shift.ShiftId,
                Date:this.Shift.ShiftDate.slice(0,-3)
            };
            var url = '';
            if(this.Title == 'Totals Drops by User'){
                url = 'audits/total/drops';
            }else if(this.Title == 'Totals Truck by User'){
                url = 'audits/total/trucks';
            }else{
                url = 'audits/total/comments';
            }
            axios
                .post(url, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
                    this.spinner = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadTotalDrops: function(Shift) {
            var str = this.$store;
            var parms = {
                ShiftHeaderNum: Shift
            };
            axios
                .post('audits/total/comments', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
                    this.spinner = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>

<style scoped>
.btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.ok-btn {
    color: red;
    text-decoration: underline;
    line-height: 2.5rem;
    cursor: pointer;
}

.cancel-btn {
    padding: 0.5em 1em;
    background-color: #d5eae7;
    color: #35907f;
    border: 2px solid #0ec5a4;
    border-radius: 5px;
    font-weight: bold;
    font-size: 16px;
    text-transform: uppercase;
    cursor: pointer;
}
</style>
